import { PositionCodeEvent } from '../core/types';

/**
 * URL 参数收集器
 * 负责从 URL 中解析 pc 参数，记录来源位置码
 */
export class UrlParamCollector {
  private debug: boolean;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  /**
   * 从当前 URL 中解析 pc 参数
   * @returns 如果找到 pc 参数，返回位置码事件；否则返回 null
   */
  collect(): PositionCodeEvent | null {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const pcValue = urlParams.get('pc');

      if (pcValue) {
        if (this.debug) {
          console.log('[MetricTracker] URL param collector found pc:', pcValue);
        }

        return {
          sourcePc: pcValue,
          eventTime: new Date(),
        };
      }

      return null;
    } catch (error) {
      console.error('[MetricTracker] Error in URL param collector:', error);
      return null;
    }
  }

  /**
   * 从指定 URL 中解析 pc 参数（用于 SPA 路由场景）
   */
  collectFromUrl(url: string): PositionCodeEvent | null {
    try {
      const urlObject = new URL(url, window.location.origin);
      const pcValue = urlObject.searchParams.get('pc');

      if (pcValue) {
        if (this.debug) {
          console.log('[MetricTracker] URL param collector found pc from URL:', pcValue);
        }

        return {
          sourcePc: pcValue,
          eventTime: new Date(),
        };
      }

      return null;
    } catch (error) {
      console.error('[MetricTracker] Error in URL param collector (from URL):', error);
      return null;
    }
  }
}
